import React from "react";
import TableHead from "@mui/material/TableHead";
import { ParentProps } from "../../types";
import "./styles.scss";

const classNameBase = "scd-table-light-head";

export default function HeadTableLight(props: ParentProps): React.JSX.Element {
  const { children } = props;

  return (
    <TableHead
      classes={{
        root: `${classNameBase}-root`,
      }}
    >
      {children}
    </TableHead>
  );
}
